export interface UserConstructorOpts {
  id: number;
  firstName: string;
  lastName: string;
  roles: UserRole[];
}

export enum UserRole {
  ADMIN = 'admin',
  CONTRIBUTOR = 'contributor',
  EDITOR = 'editor'
}

export class User {
  public readonly id: number;
  public readonly firstName: string;
  public readonly lastName: string;
  public readonly roles: UserRole[] = [];

  constructor(opts: UserConstructorOpts) {
    this.id = opts.id;
    this.firstName = opts.firstName;
    this.lastName = opts.lastName;
    this.roles = opts.roles;
  }

  get fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  get label(): string {
    return this.firstName + ' ' + this.lastName;
  }

  get hasRoles(): boolean {
    return this.roles.length > 0;
  }

  hasRole(...role: UserRole[]): boolean {
    for (const r of role) {
      if (this.roles.includes(r)) {
        return true;
      }
    }
    return false;
  }

  get isContributor(): boolean {
    return this.hasRole(UserRole.CONTRIBUTOR, UserRole.EDITOR, UserRole.ADMIN);
  }

  get isEditor(): boolean {
    return this.hasRole(UserRole.EDITOR, UserRole.ADMIN);
  }

  get isAdmin(): boolean {
    return this.hasRole(UserRole.ADMIN);
  }

  rolesLabel(): string {
    if (!this.hasRoles) return 'Standard user';

    return this.roles
      .map((role) => role.charAt(0).toUpperCase() + role.substring(1))
      .join(', ');
  }

  toJson(): any {
    return {
      id: this.id,
      first_name: this.firstName,
      last_name: this.lastName
    };
  }

  static fromJson(json: any): User {
    return new User({
      id: json.id,
      firstName: json.first_name,
      lastName: json.last_name,
      roles: (json.roles ?? []).sort()
    });
  }
}
